export const EvaluationIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.72964 8.22928C2.60309 8.10272 2.60501 7.8956 2.73157 7.76904C5.61714 4.88347 10.3834 4.88348 13.2689 7.76904C13.3955 7.8956 13.3974 8.10272 13.2709 8.22928C10.36 11.1402 5.64052 11.1402 2.72964 8.22928Z"
      fill="#00082F"
      fillOpacity="0.275"
    />
  </svg>
);
